module.exports = __webpack_public_path__ + "media/images/allcare-academy-47c96c08e42512bc6f5935dc1e752cad.png";